export default __webpack_public_path__ + "static/media/verification-approved.dbfc6b4c.svg";